<template>
	<div class="qd-card mb-1 columns-table position-relative">
		<div class="columns-container pt-2">
			<columns-table-row v-for="(column, index) in localColumns" :fields="fields" :key="column.path" :variables="variables" v-model="localColumns[index]" :index="index" @update:modelValue="columnChanged" @remove="remove" @swapItems="(dragged, dropped) => swapItems(dragged, dropped)" />
		</div>

		<div class="limit-container mt-3 mb-1" v-if="columns.length > 0">
			تعداد ردیف: <input class="qd-input limit-input" type="number" :value="limit" @input="limitChanged">
		</div>

		<div class="columns-empty" v-if="columns.length === 0">
			<div class="columns-empty-img">
				<img src="../assets/not-found.svg" alt="No Item Selected">
			</div>
			<div class="columns-empty-title">هیچ موردی انتخاب نشده است</div>
		</div>

	</div>
</template>

<script>

	export default {
		name: 'columns-table',
		props: {
			columns: {
				type: Array,
				default: () => [],
			},
			limit: {
				type: String
			},
			variables: {
				type: Array,
				default: () => [],
			}
		},
		emits: ['remove-column', 'column-changed', 'update:limit', 'swap-items'],
		data() {
			return {
				localColumns: [],
			}
		},
		watch: {
			columns: {
				deep: true,
				handler(val) {
					this.localColumns = { ...val }
				},
			},
		},
		computed: {
			fields() {
				let t = this.columns.map((column) => {
					return {
						title: column.alias && column.alias != '' ? column.alias : column.titlePath,
						path: column.path,
						type: column.type,
						enumItems: column.enumItems,
						aggregate: column.aggregate,
						fromVariable: column.fromVariable,
					}
				})
				return t
			}
		},
		methods: {
			remove(column) {
				this.$emit('remove-column', column)
			},
			columnChanged(column) {
				this.$emit('column-changed', column)
			},
			limitChanged(e) {
				console.log("🚀 ~ file: ColumnsTable.vue:77 ~ limitChanged ~ e.target.value", e.target.value)
				this.$emit('update:limit', e.target.value || null)
			},
			swapItems(dragged, dropped) {
				this.$emit('swap-items', dragged, dropped)
			}
		},
	}
</script>

<style>
	.columns {
		width: 100%;
	}

	.section-title {
		padding: 5px;
		font-weight: bold;
		margin-bottom: 3px;
		text-align: right;
	}

	.columns-container {
		display: flex;
		flex-wrap: nowrap;
		max-width: 100%;
		overflow-x: auto;
	}

	.limit-input {
		width: 70px;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
	}

	.columns-table {
		min-height: 252px;
	}

	.columns-empty-title {
		position: absolute;
		text-align: center;
		width: 100%;
		top: 50%;
		transform: translateY(-50%);
		font-size: 22px;
		font-weight: 600;
	}

	.columns-empty-img {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0.3;
	}

	.columns-empty-img img {
		width: 100%;
		height: 100%;
	}
</style>